<p>add-client-button works!</p>
